module.exports = __webpack_public_path__ + "fonts/segoeuisl.426088e4.ttf";